import * as R from 'ramda'
import * as React from 'react'

import PropTypes from 'prop-types'

export function PraxisObserver(props) {
  React.useEffect(() => {
    const query = R.pathOr({}, ['query'], props)
    localStorage.setItem('praxisMessage', JSON.stringify(query))

    // If the processing-step was opened in a new browser/tab close the window
    if (window.top === window.self) {
      window.close()
    }
  })

  return null
}

PraxisObserver.propTypes = {
  query: PropTypes.object,
}
